import React, {Fragment, useEffect, useState} from "react";
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Loading from "../components/Loading";
import {ProfileDetails} from "../components/ProfileDetails";
import {MCNumberAndALEI} from "../components/MCNumberAndALEI";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import {TickersAndPairs} from "../components/TickersAndPairs";
import UserService from "../services/UserService";
import {PageLayout} from "../components/PageLayout";
import {PageLoader} from "../components/PageLoader";
import {SubscriptionsComponent} from "../components/Subscriptions";


export const ProfileComponent = ({ onDataChange, defaultSubTabIndex = 0, onSubTabChange }) => {
    const {user, getAccessTokenSilently} = useAuth0();
    const [sharedData, setSharedData] = useState('Initial Shared Data');
    const [currentSubTabIndex, setCurrentSubTabIndex] = useState(defaultSubTabIndex);
    
    const handleDataFromChildA = (data) => {
        setSharedData(data);
        onDataChange("Data from Child A");
    };

    const handleDataFromChildB = (data) => {
        setSharedData(data);
    };

    const [state, setState] = useState({
        showResult: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
        response: undefined
    });

    let userNavigationDecider = {};


    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            UserService.userSettingsFlow(token, user).then(
                response => {
                    console.log(response);
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data,
                        response: response.data
                    });
                    userNavigationDecider = response.data

                }
            );
        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };


    // effect runs on component mount
    useEffect(() => {
        // simulate async api call with set timeout
        callApi().then();
    }, []);

    // Listen for onboarding status changes to refresh without full reload
    useEffect(() => {
        const handleOnboardingStatusChanged = () => {
            // Refresh the profile status to update tab disabled states
            callApi();
        };

        window.addEventListener('onboardingStatusChanged', handleOnboardingStatusChanged);
        
        return () => {
            window.removeEventListener('onboardingStatusChanged', handleOnboardingStatusChanged);
        };
    }, []);

    // Update sub-tab index when prop changes
    useEffect(() => {
        setCurrentSubTabIndex(defaultSubTabIndex);
    }, [defaultSubTabIndex]);

    // Handle sub-tab changes
    const handleSubTabSelect = (index) => {
        setCurrentSubTabIndex(index);
        if (onSubTabChange) {
            onSubTabChange(index);
        }
    };

    return (
        <>
            <div>
                {!state.showResult && (
                    <PageLoader />
                )}
                {state.showResult &&

                    // <div className="container-fluid">
                    <div className="">

                        <Tabs 
                            selectedIndex={currentSubTabIndex} 
                            onSelect={handleSubTabSelect}
                        >
                            <div></div>
                            <TabList className="profile-child-tabs">
                                <Tab disabled={state.response.screenOne}>Profile</Tab>
                                <Tab disabled={state.response.screenTwo}>COMPANY ID</Tab>
                                <Tab disabled={state.response.screenThree}>Subscriptions</Tab>
                                <Tab disabled={state.response.screenFour}>Tickers & City Pairs</Tab>
                            </TabList>
                            <TabPanel><ProfileDetails onDataChange={handleDataFromChildA} sharedData={sharedData}></ProfileDetails></TabPanel>
                            <TabPanel><MCNumberAndALEI onDataChange={handleDataFromChildA} sharedData={sharedData}></MCNumberAndALEI></TabPanel>
                            <TabPanel><SubscriptionsComponent onDataChange={handleDataFromChildA} sharedData={sharedData}></SubscriptionsComponent></TabPanel>
                            <TabPanel><TickersAndPairs onDataChange={handleDataFromChildA} sharedData={sharedData}></TickersAndPairs></TabPanel>
                        </Tabs>
                    </div>
                }
            </div>
        </>
    );
};

export default withAuthenticationRequired(ProfileComponent, {
    onRedirecting: () => <PageLoader/>,
});
